.card {
  background: var(--bg-panel);
  border-radius: var(--r-14);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-muted);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  padding: 5px 10px;
  border-radius: var(--r-pill);
  background: var(--bg-page);
  font-size: 13px;
  color: var(--text-secondary);
}
